import { render } from "./MsisdnsList.vue?vue&type=template&id=0d71c604&scoped=true"
import script from "./MsisdnsList.vue?vue&type=script&lang=js"
export * from "./MsisdnsList.vue?vue&type=script&lang=js"

import "./MsisdnsList.vue?vue&type=style&index=0&id=0d71c604&scoped=true&lang=css"
import "./MsisdnsList.vue?vue&type=style&index=1&id=0d71c604&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d71c604"]])

export default __exports__